import { render, staticRenderFns } from "./SingleTextareaFilter.vue?vue&type=template&id=0cc22977"
import script from "./SingleTextareaFilter.vue?vue&type=script&lang=js"
export * from "./SingleTextareaFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports